module.exports = __webpack_public_path__ + "img/42-white.91a69120.svg";